import { render } from "./WelcomeSection.vue?vue&type=template&id=7df25f6c&scoped=true"
import script from "./WelcomeSection.vue?vue&type=script&lang=js"
export * from "./WelcomeSection.vue?vue&type=script&lang=js"

import "./WelcomeSection.vue?vue&type=style&index=0&id=7df25f6c&scoped=true&lang=css"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df25f6c"]])

export default __exports__